// types
import { WARRANTY_UPDATE_ADDITIONAL_INFO, UPDATE_LOADER } from '@/store/types'

// api
import { apiPostAdditionalInfo } from '@/services/API/additionalInfo'

export default {
  [WARRANTY_UPDATE_ADDITIONAL_INFO]({ state, commit }) {
    if (state.created) {
      commit(UPDATE_LOADER, true, { root: true })
      return apiPostAdditionalInfo(
        state.name,
        state.surname,
        state.phone,
        state.email,
        state.scoreAsk,
        state.validateContract,
        state.inmobiliere,
        state.embellissement,
        state.mobiliere,
        state.piscine,
        state.exterieur,
        state.currentClaim,
        state.gagNumber,
        state.renNumber,
        state.sinisterCause
      )
        .catch(errorCode => {
          /* apiGetSinister(this.stateWarrantySinisterId).then(sinister => {
            commit(WARRANTY_UPDATE_ADDRESS, sinister.address)
            commit(WARRANTY_UPDATE_ZIP_CODE, sinister.zip_code)
          }) */

          return Promise.reject(errorCode)
        })
        .finally(() => {
          commit(UPDATE_LOADER, false, { root: true })
        })
    }
  }
}
